import RestService from "./restService";
import { DYNAMIC_FIELDS } from "../../url";

const singleton = Symbol();
const singletonEnforcer = Symbol();

class DynamicFieldsService extends RestService {
  constructor(enforcer) {
    super(DYNAMIC_FIELDS);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct DynamicFieldsService more than one");
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new DynamicFieldsService(singletonEnforcer);
    }
    return this[singleton];
  }

  getAllFields() {
    return this._api_connector.get(DYNAMIC_FIELDS.uri("table").url);
  }

  getField(fieldId) {
    return this._api_connector.get(DYNAMIC_FIELDS.uri("table").uri(fieldId).url);
  }

  createField(payload) {
    return this._api_connector.post(DYNAMIC_FIELDS.uri("table").url, payload);
  }

  updateField(payload) {
    return this._api_connector.put(DYNAMIC_FIELDS.uri("table").url, payload);
  }

  deleteField(fieldId) {
    return this._api_connector.delete(DYNAMIC_FIELDS.uri("table").uri(fieldId).url);
  }

  createSubField(fieldId, payload) {
    return this._api_connector.post(DYNAMIC_FIELDS.uri("table").uri(fieldId).uri("fields").url, payload);
  }

  updateSubField(fieldId, payload) {
    return this._api_connector.put(DYNAMIC_FIELDS.uri("table").uri(fieldId).uri("fields").url, payload);
  }

  deleteSubField(fieldId, fieldKey) {
    return this._api_connector.delete(DYNAMIC_FIELDS.uri("table").uri(fieldId).uri("fields").uri(fieldKey).url);
  }

  getFieldData(payload) {
    return this._api_connector.post(DYNAMIC_FIELDS.uri("query").url, payload, {
      meta: {
        disableResponseListener: true
      }
    });
  }

  createFieldData(fieldId, payload) {
    return this._api_connector.post(DYNAMIC_FIELDS.uri("table").uri(fieldId).uri("data").url, payload);
  }

  updateFieldData(fieldId, dataId, payload) {
    return this._api_connector.put(DYNAMIC_FIELDS.uri("table").uri(fieldId).uri("data").uri(dataId).url, payload);
  }

  deleteFieldData(dataId, tableId) {
    return this._api_connector.delete(DYNAMIC_FIELDS.uri("data").uri(dataId).uri(tableId).url);
  }

  saveEmployeeData(payload) {
    return this._api_connector.post(DYNAMIC_FIELDS.uri("employee-data").url, payload);
  }

  getAllEmployeeData(organizationId, employeeId) {
    return this._api_connector.get(DYNAMIC_FIELDS.uri("employee-data").uri(organizationId).uri(employeeId).url);
  }

  getEmployeeData(organizationId, employeeId, tableId) {
    return this._api_connector.get(
      DYNAMIC_FIELDS.uri("employee-data").uri(organizationId).uri(employeeId).uri(tableId).url
    );
  }

  deleteEmployeeData(employeeId, dataId) {
    return this._api_connector.delete(DYNAMIC_FIELDS.uri("employee-data").uri(employeeId).uri(dataId).url);
  }

  multipleAssignEmployeeData(payload) {
    return this._api_connector.post(DYNAMIC_FIELDS.uri("bulk-match-employee-data").url, payload);
  }
}

export default DynamicFieldsService;
